module.exports = __webpack_public_path__ + "img/013.63032ae5.png";